import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

const useOneLinkSmartScriptV2 = (options) => {
  const baseLink = 'https://unacademy.onelink.me/RICs/';
  const [oneLinkURL, setoneLinkURL] = useState(null);
  const { asPath } = useRouter();

  useEffect(() => {
    if (!window.AF_SMART_SCRIPT) return;
    const mediaSource = {
      keys: [],
      defaultValue: ['Mweb_download']
    };
    const campaign = {
      keys: [],
      defaultValue: [options?.campaign || 'Mweb']
    };
    const deepLinkValue = { keys: [], defaultValue: asPath.slice(1) };
    const deep_link_sub1 = {
      paramKey: 'deep_link_sub1',
      keys: [],
      defaultValue: 'app_deeplink'
    };
    const result = window.AF_SMART_SCRIPT.generateOneLinkURL({
      oneLinkURL: baseLink,
      afParameters: {
        mediaSource,
        campaign,
        deepLinkValue,
        afCustom: [deep_link_sub1]
      }
    });
    if (result) {
      setoneLinkURL(result.clickURL);
    }
  }, [asPath, baseLink, options]);

  return oneLinkURL;
};

export default useOneLinkSmartScriptV2;
